<template>
  <transition
    v-if="slotPassed"
    enter-active-class="transition ease-out duration-200"
    enter-from-class="opacity-0 -translate-y-1"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition ease-in duration-150"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 -translate-y-1"
  >
    <div v-show="openMenu || false" class="hidden md:block absolute z-50 inset-x-0 transform shadow-md">
      <div class="bg-white rounded-b-xs border-t border-gray-100">
        <div class="max-w-7xl mx-auto grid gap-x-6 gap-y-6 px-2 py-4 sm:grid-cols-2 sm:px-4 lg:px-6 lg:py-6" :class="gridColumns">
          <slot />
        </div>
      </div>
      <div v-if="footer" class="bg-gray-50">
        <div class="max-w-7xl mx-auto space-y-6 px-4 py-5 sm:flex sm:space-y-0 sm:space-x-10 sm:px-6 lg:px-8"><slot name="footer" /></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    columns: {
      type: Number,
      default: 2
    },
    openMenu: {
      type: Boolean,
      default: false
    },
    slotPassed: {
      type: Boolean,
      default: false
    },
    footer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    gridColumns() {
      return `lg:grid-cols-${this.columns}`
    }
  }
}
</script>

<style></style>
